import React from "react";

const LoaderSpiner = () => {
  return (
    <span class="loader"></span>
  );
};

export default LoaderSpiner;
